import * as React from "react";

const LinkedinIcon = (props) => (
  <svg
    viewBox="0 0 183.836 179.898"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M21.566 0C9.07 0 0 8.617 0 20.488c0 11.864 8.89 20.475 21.137 20.475 6.351 0 11.824-2.059 15.828-5.955 3.84-3.738 5.957-8.895 5.953-14.614C42.637 8.387 33.855 0 21.566 0zm9.82 29.273c-2.48 2.415-6.026 3.69-10.25 3.69C13.403 32.963 8 27.834 8 20.488 8 13.02 13.453 8 21.566 8c7.934 0 13.172 4.94 13.352 12.49 0 3.448-1.254 6.566-3.531 8.783zM3.836 179.898h35.953V47.721H3.836v132.177zm8-124.177h19.953v116.177H11.836V55.721zM134.594 47.72c-16.672 0-26.88 5.754-32.793 11.167l-1.125-11.166H60v132.177h39.836v-69.47c0-2.992 1.21-9.206 1.973-10.846 4.812-10.365 11.304-10.365 21.136-10.365 11.325 0 20.891 10.619 20.891 23.187v67.494h40v-74.681c0-39.504-25.527-57.496-49.242-57.496zm41.242 124.178h-24v-59.494c0-16.906-13.23-31.187-28.89-31.187-10.048 0-21.434 0-28.395 14.998-1.438 3.1-2.715 10.529-2.715 14.213v61.47H68V55.721h25.442l1.632 16.177h6.555l1.172-1.89c2.668-4.295 11.105-14.287 31.793-14.287 19.863 0 41.242 15.488 41.242 49.496v66.681z" />
  </svg>
);

export default LinkedinIcon;
